export default {
    prompt_title: 'Are you working this edit?',
    prompt_title_plural: 'Are you working these edits?',
    // Shown under the title. Explains why the edit is sitting in their name.
    reason_client_revision: 'The client requested changes on an edit you delivered, so it came back to you.',
    reason_qc_re_edit: 'Quality Control sent your version back for changes, so it came back to you.',
    reason_bid_award: 'You won the request for this edit, so it is assigned to you.',
    reason_generic: 'This edit was assigned back to you automatically.',
    caption_with_deadline:
        'Confirm within {hours}h and it stays yours. With no answer it returns to Ready to Edit for any editor to claim.',
    // Scale Coach is watching: its deadline moves with awake hours, so no fixed number is promised.
    caption_watched:
        "Confirm now to keep it. Scale Coach will DM you on Teams before it moves back to Ready to Edit, and you'll have an hour from that message.",
    caption_no_deadline: 'Confirm that you are working this edit so it stays assigned to you.',
    // Rendered from `deadline_at`, so these track the real release deadline as the clock moves.
    time_left: '{hours}h left to confirm',
    time_left_minutes: '{minutes}m left to confirm',
    time_left_overdue: 'Past due — this edit can return to Ready to Edit at any time',
    mark_as_working: 'Mark as working',
    marking: 'Confirming…',
    decide_later: 'Decide later',
    open_edit: 'Open the edit',
    counter: '{current} of {total}',
    // Proofing-room banner.
    banner_title: 'This edit is waiting on your confirmation',
    banner_caption_with_deadline:
        'It came back to you automatically. Confirm within {hours}h or it returns to Ready to Edit for any editor to claim.',
    banner_caption_watched:
        "It came back to you automatically. Confirm now to keep it. Scale Coach will DM you on Teams before it moves back to Ready to Edit, and you'll have an hour from that message.",
    banner_caption_no_deadline: 'It came back to you automatically. Confirm that you are working it.',
    // Claim confirmation checkbox.
    claim_acceptance: "I'm accepting this video and I'm ready to start working now",
    claim_acceptance_required: 'Please confirm you are ready to start working before claiming.',
}
